import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    directorships: [],
  },
  mutations: {
    setDirectorships (state, directorships) {
      Vue.set(state, 'directorships', directorships);
    },
  },
  actions: {
    fetchDirectorships ({ commit, rootState }) {
      return this.$axios.get(`${rootState.endpoints.filings}/${rootState.filing.currentFilingId}/directorships`).then(response => {
        return commit('setDirectorships', response.data);
      }).catch(error => {
        return error.message;
      });
    },
  },
};